export enum ProductStatusEnum {
  Active = 'Active',
  InActive = 'In Active',
  Draft = 'Draft',
}

export const ProductStatus = {
  active: {
    value: ProductStatusEnum.Active,
    description: 'Active',
  },
  inActive: {
    value: ProductStatusEnum.InActive,
    description: 'In Active',
  },
  draft: {
    value: ProductStatusEnum.Draft,
    description: 'You are still working on this product.',
  },
}
